var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"minwidth mw100"},[_c('el-carousel',{ref:"carousel",attrs:{"trigger":"click","height":"50vw","arrow":"never","autoplay":_vm.autoplay}},_vm._l((_vm.picList),function(item){return _c('el-carousel-item',{key:item.img},[_c('div',{staticClass:"swipediv"},[_c('img',{staticClass:"swipeimg",attrs:{"src":item.img}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }